export default __webpack_public_path__ + "static/soehne-web-halbfett-kursiv-71555d4e28483935fed0196dba7b9497.woff";